export const defaultDotMarkSizes = {
  small: 8,
  normal: 12,
} as const;

export type DotMarkSizes = keyof typeof defaultDotMarkSizes;
